

export const isError = (error: Error | string | any): error is Error => {
  return (error as Error).message !== undefined;
};
